import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vShow as _vShow, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bf-modal bf-modal--profile-edit bf-modal--has-sections"
}
const _hoisted_2 = { class: "bf-modal__section" }
const _hoisted_3 = { class: "d-flex justify-content-between" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "bf-heading-script text-primary mb-3" }, "Persönliche Daten", -1)
const _hoisted_5 = { class: "flex-shrink-0" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "mb-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Name", -1)
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "mb-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "profile-edit-input-consent-newsletter"
}, "buggyFit Newsletter abonnieren", -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Daten aktualisieren ")
const _hoisted_14 = { class: "fa fa-fw fa-spinner fa-spin ml-1" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "d-none"
}, "Daten aktualisieren", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextField = _resolveComponent("TextField")!
  const _component_FieldError = _resolveComponent("FieldError")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    modelValue: _ctx.shownLocal,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.shownLocal) = $event)),
    close: _ctx.closeModal
  }, {
    default: _withCtx(() => [
      (_ctx.profile)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("form", {
                onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"])),
                novalidate: "",
                class: ""
              }, [
                _createElementVNode("div", _hoisted_3, [
                  _hoisted_4,
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("a", {
                      href: "#",
                      class: "modal-close-button",
                      "aria-label": "Schließen",
                      onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)), ["prevent"]))
                    }, _hoisted_7)
                  ])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createElementVNode("input", {
                    type: "text",
                    class: _normalizeClass(["form-control", {'is-disabled': true}]),
                    disabled: "",
                    style: {"opacity":"0.5"},
                    value: _ctx.profile.prename + ' ' + _ctx.profile.surname
                  }, null, 8, _hoisted_10)
                ]),
                _createVNode(_component_TextField, {
                  class: "mb-3",
                  field: "phone_mobile",
                  errors: _ctx.errors,
                  modelValue: _ctx.form.phone_mobile,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.phone_mobile) = $event)),
                  label: "Telefonnummer",
                  prefix: "profile-edit"
                }, null, 8, ["errors", "modelValue"]),
                _createVNode(_component_TextField, {
                  class: "mb-4",
                  field: "email",
                  errors: _ctx.errors,
                  modelValue: _ctx.form.email,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.email) = $event)),
                  label: "E-Mail-Adresse",
                  prefix: "profile-edit"
                }, null, 8, ["errors", "modelValue"]),
                _createElementVNode("div", _hoisted_11, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    class: _normalizeClass(["d-none form-check-input", {'is-invalid': _ctx.errors.consent_newsletter || false}]),
                    id: "profile-edit-input-consent-newsletter",
                    "aria-describedby": "profile-edit-input-consent-newsletter-description",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.consent_newsletter) = $event))
                  }, null, 2), [
                    [_vModelCheckbox, _ctx.form.consent_newsletter]
                  ]),
                  _hoisted_12,
                  _createVNode(_component_FieldError, {
                    errors: _ctx.errors.consent_newsletter || []
                  }, null, 8, ["errors"])
                ]),
                _createElementVNode("a", {
                  href: "#",
                  class: "btn btn-primary",
                  onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
                }, [
                  _hoisted_13,
                  _withDirectives(_createElementVNode("i", _hoisted_14, null, 512), [
                    [_vShow, _ctx.loading]
                  ])
                ]),
                _hoisted_15
              ], 32)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue", "close"]))
}